import { render, staticRenderFns } from "./returnFixedPurchase.vue?vue&type=template&id=3598eeeb&scoped=true&"
import script from "./returnFixedPurchase.vue?vue&type=script&lang=js&"
export * from "./returnFixedPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3598eeeb",
  null
  
)

export default component.exports